import type { CSSProperties, FC, ReactElement } from 'react';
import { Fragment } from 'react';

import type { LoaderSpinnerTheme } from '@snowit/icetypes';

import cx from 'classnames';
import s from './LoaderSpinner.module.scss';

export interface ILoaderSpinner {
  theme?: LoaderSpinnerTheme;
  size?: number;
  id?: string;
  className?: string;
}

const LoaderSpinner: FC<ILoaderSpinner> = (props: ILoaderSpinner): ReactElement => {
  const { theme = 'bars', size = 16, id, className } = props;

  const renderHexagon = () => {
    return (
      <Fragment>
        <svg width='14px' height='16px' viewBox='0 0 14 16'>
          <path d='M7.61538462,0.355292473 L13.3128186,3.64470753 C13.6936199,3.86456327 13.9282032,4.27087345 13.9282032,4.71058495 L13.9282032,11.2894151 C13.9282032,11.7291265 13.6936199,12.1354367 13.3128186,12.3552925 L7.61538462,15.6447075 C7.23458329,15.8645633 6.76541671,15.8645633 6.38461538,15.6447075 L0.687181385,12.3552925 C0.30638006,12.1354367 0.0717967697,11.7291265 0.0717967697,11.2894151 L0.0717967697,4.71058495 C0.0717967697,4.27087345 0.30638006,3.86456327 0.687181385,3.64470753 L6.38461538,0.355292473 C6.76541671,0.135436726 7.23458329,0.135436726 7.61538462,0.355292473 Z' />
        </svg>
        <svg width='14px' height='16px' viewBox='0 0 14 16'>
          <path d='M7.61538462,0.355292473 L13.3128186,3.64470753 C13.6936199,3.86456327 13.9282032,4.27087345 13.9282032,4.71058495 L13.9282032,11.2894151 C13.9282032,11.7291265 13.6936199,12.1354367 13.3128186,12.3552925 L7.61538462,15.6447075 C7.23458329,15.8645633 6.76541671,15.8645633 6.38461538,15.6447075 L0.687181385,12.3552925 C0.30638006,12.1354367 0.0717967697,11.7291265 0.0717967697,11.2894151 L0.0717967697,4.71058495 C0.0717967697,4.27087345 0.30638006,3.86456327 0.687181385,3.64470753 L6.38461538,0.355292473 C6.76541671,0.135436726 7.23458329,0.135436726 7.61538462,0.355292473 Z' />
        </svg>
      </Fragment>
    );
  };

  const renderBars = () => {
    return (
      <Fragment>
        <div />
        <div />
        <div />
      </Fragment>
    );
  };

  const renderCircle = () => {
    return <div />;
  };

  const renderLoader = () => {
    switch (theme) {
      case 'circle':
        return renderCircle();
      case 'bars':
        return renderBars();
      case 'hexagon':
      default:
        return renderHexagon();
    }
  };

  return (
    <div
      id={id}
      className={cx(s.loader, className, { [s[theme]]: true })}
      style={{ '--loader-size': size } as CSSProperties}
    >
      {renderLoader()}
    </div>
  );
};

export default LoaderSpinner;
